import React from 'react'
import Logo from 'components/Logo'
import './style.css'

const AppsPageHeader = () => (
  <div className="apps-page-header">
    <h1 className="apps-page-header-title">
      <b>Drift</b> Developer Platform
    </h1>
    <Logo
      className="apps-page-header-logo"
      color="#394f5a"
    />
  </div>
)

export default AppsPageHeader
